<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.change_user'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex flex-col gap-4 mt-5">
            <div class="flex gap-2 items-center" v-for="user in users" :key="user.id">
                <div>
                    <InertiaSquareLinkButton
                        method="post"
                        as="button"
                        action="change_user"
                        :href="user.links.store"
                        :disabled="user.is_current"
                    />
                </div>
                <div>
                    <div>
                        {{ user.school_name }}
                    </div>
                    <div class="text-sm text-gray-500">
                        {{ user.full_name }}
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';

export default {
    components: {
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'users'],
    data() {
        return {};
    },
};
</script>
